export default {
  id: 'dashboard',
  nav: [{ group: 'main', label: 'Dashboard', path: '/', icon: 'dashboard', order: 10, match: /^\/$/ }],
  routes: [
    { path: '/', title: 'Dashboard', breadcrumbs: ['Dashboard'], view: () => import('./views/dashboard.view.js') },
  ],
};
